import React, {useEffect, useRef, useState} from 'react';
import {useParams, useNavigate, Link} from 'react-router-dom'
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedPerson} from "../../../recoils/recoil";
import api from '../../../services/api'
import styles from "./BiographyList.module.css";

const BiographyList = () => {
    const {event_id} = useParams();
    const navigate = useNavigate();

    // getter
    const selectedPersonList = useRecoilValue(selectedPerson);
    // setter
    const setSelectedPersonList = useSetRecoilState(selectedPerson);

    const [activeItem, setActiveItem] = useState([]);
    const [activeItemSub, setActiveItemSub] = useState([]);
    const [eventInfo, setEventInfo] = useState([]);
    const [allEventItems, setAllEventItems] = useState([]); // 원본 데이터 유지
    const [eventItems, setEventItems] = useState([]); // 화면에 표시할 원본 데이터
    const [pageEventItems, setPageEventItems] = useState([]); // 페이지 데이터 최종 화면에 표실할 원본 데이터
    const [page, setPage] = useState(1);
    const observerRef = useRef(null);
    const dataPerPage = 20;
    const scrollRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState(""); // 검색어 상태
    const [isSearch, setIsSearch] = useState(false); // 검색 여부
    const [isSearchQuery, setIsSearchQuery] = useState(""); // 검색어 입력 여부
    const [orderKey, setOrderKey] = useState("authors"); // 정렬 기준
    const [orderType, setOrderType] = useState("asc"); // 정렬 순서
    const [isLoading, setIsLoading] = useState(true);


    // 책 클릭시 펼침
    const handleToggle = (event, index) => {
        setActiveItem((prev) =>
            prev === null || prev === undefined // ✅ null이면 최초 클릭한 index를 배열에 추가
                ? [index]
                : prev.includes(index)
                    ? prev.filter(item => item !== index) // 제거
                    : [...prev, index] // 추가
        );
    };


    // 목차 클릭시 펼침
    const handleToggleSub = (index) => {
        setActiveItemSub((prev) =>
            prev === null || prev === undefined
                ? [index]
                : prev.includes(index)
                    ? prev.filter(item => item !== index)
                    : [...prev, index]
        );
    };

    const handleSearch = (query) => {
        setActiveItem(null);
        setActiveItemSub(null);
        setSearchQuery(query);

        if (query.trim() === "") {
            setIsSearch(false);
            setIsSearchQuery(query);

            const newPosts = sortItems(allEventItems, orderKey, orderType);
            setEventItems(newPosts);

            setPage(1);

            if (scrollRef.current) {
                scrollRef.current.scrollTop = 0;
            }
            return;
        }
        setIsSearch(true);
        setIsSearchQuery(query);

        const filteredItems = allEventItems.filter((item) =>
            (item.book.book.book_title || "").includes(query) ||
            (item.book.book.authors || "").includes(query) ||
            (item.book.book.publisher || "").includes(query) ||
            (String(item.book.book.publish_year || "")).includes(query) ||
            (item.book.book.library || "").includes(query)
        );

        // 기존 데이터와 다를 때만 `setEventItems` 실행
        const newPosts = sortItems(filteredItems, orderKey, orderType);
        setEventItems(newPosts);
        setPage(1);

        if (scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    };

    const handleSort = (key) => {
        let newOrderType = "asc";

        if (orderKey === key) {
            // 동일한 정렬 키를 클릭하면 오름차순 ↔ 내림차순 변경
            newOrderType = orderType === "asc" ? "desc" : "asc";
        }
        setActiveItem(null);
        setActiveItemSub(null);
        // 새로운 정렬 키를 클릭하면 기본 오름차순으로 설정
        setOrderKey(key);
        setOrderType(newOrderType);

        const sortedItems = sortItems(eventItems, key, newOrderType);
        setEventItems(sortedItems); // 바로 정렬된 데이터 반영

        setPage(1);

        if (scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    }

    const handlePersonClick = (order) => {
        // 중복된 person_id가 이미 존재하는 경우 추가하지 않음
        const exists = selectedPersonList.some(person => person.id === order.person_id);

        console.log(order)

        const updatedList = exists
            ? [...selectedPersonList] // 기존 순서 유지
            : [...selectedPersonList, {id: order.person_id, name: order.primaryname, nameKo: order.primaryname_ko}];

        setSelectedPersonList(updatedList);

        const idList = updatedList.map(person => person.id);

        // 배열에 넣어서 personId 보내기
        navigate(`/person/${idList}`);
    };

    // 숫자가 아니면 리다이렉트
    useEffect(() => {
        // event_id 가 숫자가 아니거나, 존재하지 않는 경우 리다이렉트
        if (!event_id || isNaN(Number(event_id))) {
            navigate("/biography_about");
        }
    }, [event_id, navigate]);

    const isHangul = (text) => /^[\uAC00-\uD7A3]/.test(text); // 한글 유니코드 범위 체크

    const sortItems = (items, key, order = "asc") => {
        const sortedItems = [...items].sort((a, b) => {
            // 정렬 대상 필드 추출
            let valueA, valueB;

            switch (key) {
                case "authors":
                    valueA = a.book.book.authors?.trim() || "zzz";
                    valueB = b.book.book.authors?.trim() || "zzz";
                    break;
                case "book_title":
                    valueA = a.book.book.book_title?.trim() || "";
                    valueB = b.book.book.book_title?.trim() || "";
                    break;
                case "publisher":
                    valueA = a.book.book.publisher?.trim() || "";
                    valueB = b.book.book.publisher?.trim() || "";
                    break;
                case "publish_year":
                    valueA = a.book.book.publish_year ? parseInt(a.book.book.publish_year, 10) : 0;
                    valueB = b.book.book.publish_year ? parseInt(b.book.book.publish_year, 10) : 0;
                    break;
                case "library":
                    valueA = a.book.book.library?.trim() || "";
                    valueB = b.book.book.library?.trim() || "";
                    break;
                default:
                    return 0;
            }

            const isAHangul = isHangul(valueA);
            const isBHangul = isHangul(valueB);
            if (isAHangul && !isBHangul) return -1; // 한글이 먼저 오도록
            if (!isAHangul && isBHangul) return 1; // 한자가 뒤로 가도록

            // 문자열 비교
            let result;
            if (typeof valueA === "string" && typeof valueB === "string") {
                result = valueA.localeCompare(valueB, "ko", {sensitivity: "base"});
            } else {
                result = valueA - valueB;
            }

            return order === "asc" ? result : -result;
        });

        return sortedItems;
    };


    useEffect(() => {
        const getTags = async () => {
            setActiveItem(null);
            setActiveItemSub(null);
            setIsSearch(false);
            setIsSearchQuery("");
            setSearchQuery("");
            setIsLoading(true);
            try {
                const response = await api.get(`/get_books_with_paragraphs_by_event_id/${event_id}`);
                if (response.status === 200 && response.data) {
                    setEventInfo(
                        {
                            event_id: response.data.event.event_id,
                            event_type: response.data.event.event_type,
                            event_category: response.data.event.event_category,
                            event_tag: response.data.event.event_tag,
                        }
                    );

                    const items = response.data.event.books.map((item) => ({
                        book: item,
                    }));

                    const sortedEvents = sortItems(items, "authors", "asc");

                    // 상태가 변경될 때만 setState 호출 (불필요한 렌더링 방지)
                    if (JSON.stringify(allEventItems) !== JSON.stringify(sortedEvents)) {
                        setAllEventItems(sortedEvents);
                        setEventItems(sortedEvents);

                        setPageEventItems([]);
                        const newPosts = sortedEvents.slice(0, dataPerPage);
                        if (newPosts.length > 0) {
                            setPageEventItems((prevPosts) => Array.isArray(prevPosts) ? [...prevPosts, ...newPosts] : [...newPosts]);
                        }
                    }

                    setIsLoading(false);

                    if (scrollRef.current) {
                        scrollRef.current.scrollTop = 0;
                    }
                }
            } catch (error) {
                console.error("이벤트 도서 데이터 오류:", error);
                setAllEventItems([]);
                setEventItems([]);
                setPageEventItems([]);
                navigate("/biography_about");
            }
        };

        getTags();
    }, [event_id]); // event_id 변경 시만 실행

    const loadMorePosts = (page) => {
        if (page === 1) setPageEventItems([]);

        if (!eventItems || !Array.isArray(eventItems)) {
            console.error("Data is not available or not an array:", eventItems);
            return;
        }

        const startIndex = (page - 1) * dataPerPage;
        const endIndex = startIndex + dataPerPage;
        const newPosts = eventItems.slice(startIndex, endIndex);

        if (newPosts.length > 0) {
            setPageEventItems((prevPosts) => [...prevPosts, ...newPosts]);
        }
    };

    useEffect(() => {
        if (page === 1) {
            loadMorePosts(1);
        }
    }, [eventItems]);

    useEffect(() => {
        if (page === 1) setPageEventItems([]);

        loadMorePosts(page); // 페이지 로드
    }, [page]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setPage((prevPage) => prevPage + 1); // 다음 페이지 로드
                }
            },
            {threshold: .5} // 완전히 보였을 때 트리거
        );

        // 최초 로드 시 옵저버 설정
        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            // 옵저버 해제
            if (observer && observerRef.current) {
                observer.unobserve(observerRef.current);
            }
            observer.disconnect(); // 옵저버 완전 해제
            setPageEventItems(new Set());
            setPage(1);
        };
    }, []);


    const SortButton = ({title, sortKey, orderKey, orderType, handleSort}) => {
        return (
            <>
                <button type="button" onClick={() => handleSort(sortKey)}>
                    <span className={styles.resultSortTitle}>{title}</span>
                    <span className={styles.resultSortButton}>
                    {orderKey === sortKey ? (orderType === 'asc' ? '▲' : '▼') : '△'}
                    </span>
                </button>
            </>
        );
    };

    const sortOptions = [
        {title: "저자", key: "authors"},
        {title: "제목", key: "book_title"},
        {title: "출판사", key: "publisher"},
        {title: "출판년도", key: "publish_year"},
        {title: "소장처", key: "library"},
    ];


    return (
        <main id="contents">
            <div className="sub-content">
                <div className="biography-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">회고록</h2>
                                <p className="text">
                                    과거와 현재를 이어주는 회고록을 들여다보며, <br/>
                                    우리네의 삶 속에서 겪었던 다양한 교육적 경험을 확인할 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="w-set">
                            <div className="list-wrap">
                                <div className="list-top">
                                    <div className="search-text">
                                        <span>태그로 찾은 회고록 목록입니다.</span>
                                        <div className="search-tag">
                                            <i className="i-text"></i>
                                            <p className="tag-text">{eventInfo?.event_tag}</p>
                                        </div>
                                    </div>
                                    <div className="search-wrap">
                                        <div className="search-box">
                                            <div className="search-area">
                                                <div className="input-wrap">
                                                    <input
                                                        type="text"
                                                        placeholder="검색어를 입력하세요..."
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)} // 입력 시 상태 업데이트
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                handleSearch(searchQuery); // 엔터 누르면 검색 실행
                                                            }
                                                        }}
                                                    />
                                                    <button type="button" className="btn-search" onClick={() => handleSearch(searchQuery)}>검색</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="legend-wrap legend-indicate">
                                        <ul className="legend-area">
                                            <li><i className="person"></i>인물</li>
                                            <li><i className="institutes"></i>기관</li>
                                            <li><i className="regions"></i>지리</li>
                                            <li><i className="schools"></i>학교</li>
                                            <li><i className="time"></i>날짜</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="list-btm">
                                    {eventInfo?.event_category ? (
                                        <div className={styles.resultWrap}>
                                            {isSearch ? (
                                                <p className="result-text" style={{margin: '0'}}>
                                                    &#8242;<span>{isSearchQuery}</span>&#8242; 로 검색하신 결과는 <em>총 {eventItems.length}건</em> 입니다.
                                                </p>
                                            ) : (
                                                <p className="result-text" style={{margin: '0'}}>검색하신 결과는 <em>총 {eventItems.length}건</em> 입니다.</p>
                                            )}
                                            <div className={styles.resultSort}>
                                                {sortOptions.map((option) => (
                                                    <SortButton
                                                        key={option.key}
                                                        title={option.title}
                                                        sortKey={option.key}
                                                        orderKey={orderKey}
                                                        orderType={orderType}
                                                        handleSort={handleSort}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.resultWrap}>
                                            <p className="result-text" style={{margin: '0'}}>데이터를 가져오는 <em>중</em> 입니다.</p>
                                            <div className={styles.resultSort}><span className={styles.resultSortTitle}>저자 기본 정렬입니다.</span></div>
                                        </div>
                                    )}
                                    <div className="table-wrap">
                                        <div ref={scrollRef} className="scroll-table" style={{maxHeight: "680px", overflow: "auto"}}>
                                            {Array.isArray(pageEventItems) && pageEventItems.length > 0 ? (
                                                pageEventItems.map((item, index) => (
                                                    <dl className="list-row" key={`book-${index}`}>
                                                        <dt>
                                                            <div
                                                                className={`list-info ${(activeItem || []).includes(index) ? "on" : ""}`}
                                                                onClick={(event) => handleToggle(event, index)}
                                                            >
                                                                <p>{item.book.book.authors}</p>
                                                                <p className="title">{item.book.book.book_title}</p>
                                                                <p>{item.book.book.publisher}</p>
                                                                <p>{item.book.book.publish_year}</p>
                                                                <p className="office">
                                                                    {item.book.book.library}
                                                                </p>
                                                                <i className="i-toggle"></i>
                                                            </div>
                                                        </dt>
                                                        {item.book.tocs.map((toc, tocIndex) => (
                                                            <dd
                                                                key={`toc-${toc.toc.toc_id}`}
                                                                style={{
                                                                    height: (activeItem || []).includes(index) ? "auto" : "0",
                                                                    overflow: "hidden",
                                                                    transition: "height 0.3s ease-in-out",
                                                                }}
                                                                onClick={() => handleToggleSub(toc.toc.toc_id)}
                                                            >
                                                                <div className="toc-row">
                                                                    <div className={`list-toc ${(activeItemSub || []).includes(toc.toc.toc_id) ? "on" : ""}`}>
                                                                        <p>{toc.toc.toc_title}</p>
                                                                        <i className="i-toggle"></i>
                                                                    </div>
                                                                    <div className="content-wrap">
                                                                        {toc.paragraphs.map((paragraph, index) => (
                                                                            <div className="list-content" key={`paragraph-${index}`}>
                                                                                <div className="page">
                                                                                    <span>페이지</span>
                                                                                    <span className="num">{(paragraph.page_start === '' ? '-' : paragraph.page_start)}</span>
                                                                                </div>
                                                                                <p>{paragraph.record_text}</p>
                                                                                {paragraph.events?.length > 0 && (
                                                                                    <div className="hashtag-wrap">
                                                                                        <ul>
                                                                                            {paragraph.events.map((event, index) => (
                                                                                                <li key={`event-${index}`} style={{paddingLeft: '40px'}}><Link to={`/biography_list/${event.event_id}#${event.event_tag}`}>{event.event_tag}</Link></li>
                                                                                            ))}
                                                                                        </ul>
                                                                                    </div>
                                                                                )}
                                                                                {(paragraph.persons?.length > 0 ||
                                                                                    paragraph.institutions?.length > 0 ||
                                                                                    paragraph.resions?.length > 0 ||
                                                                                    paragraph.schools?.length > 0 ||
                                                                                    paragraph.times?.length > 0) && (
                                                                                    <div className="legend-wrap">
                                                                                        <ul className="legend-area">
                                                                                            {paragraph.persons?.length > 0 && (
                                                                                                <li>
                                                                                                    <i className="person"></i>
                                                                                                    <div className="legend-text">
                                                                                                        {paragraph.persons.map((person, index) => (
                                                                                                            <span key={`person-${index}`}><button onClick={() => handlePersonClick(person)}>{person.primaryname}</button></span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </li>
                                                                                            )}
                                                                                            {paragraph.institutions?.length > 0 && (
                                                                                                <li>
                                                                                                    <i className="institutes"></i>
                                                                                                    <div className="legend-text">
                                                                                                        {paragraph.institutions.map((institution, index) => (
                                                                                                            <span key={`institution-${index}`}>{institution.primaryname}</span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </li>
                                                                                            )}
                                                                                            {paragraph.resions?.length > 0 && (
                                                                                                <li>
                                                                                                    <i className="regions"></i>
                                                                                                    <div className="legend-text">
                                                                                                        {paragraph.resions.map((resion, index) => (
                                                                                                            <span key={`resion-${index}`}>{resion.primaryname}</span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </li>
                                                                                            )}
                                                                                            {paragraph.schools?.length > 0 && (
                                                                                                <li>
                                                                                                    <i className="schools"></i>
                                                                                                    <div className="legend-text">
                                                                                                        {paragraph.schools.map((school, index) => (
                                                                                                            <span key={`school-${index}`}><Link to={`/school_search/${school.primaryname}`}>{school.primaryname}</Link></span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </li>
                                                                                            )}
                                                                                            {paragraph.times?.length > 0 && (
                                                                                                <li>
                                                                                                    <i className="time"></i>
                                                                                                    <div className="legend-text">
                                                                                                        {paragraph.times?.map((time, index) => (
                                                                                                            <span key={`time-${index}`}>{time.date_text}</span>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </li>
                                                                                            )}
                                                                                        </ul>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </dd>
                                                        ))}
                                                    </dl>
                                                ))
                                            ) : (
                                                <dl className="list-row">
                                                    <div className="empty">
                                                        {isSearch ? (
                                                            <p>찾으시는 검색결과가 없습니다.</p>
                                                        ) : (
                                                            <p>태그 검색중입니다.</p>
                                                        )}
                                                    </div>
                                                </dl>
                                            )}
                                            <div ref={observerRef} style={{height: "20px"}}/>
                                        </div>
                                    </div>
                                </div>
                                {isLoading && (
                                    <div className="load-wrap">
                                        <div className="load-box">
                                            <div className="square"></div>
                                            <div className="square"></div>
                                            <div className="square"></div>
                                            <div className="square"></div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
        ;
};

export default BiographyList;